var K = Object.defineProperty, M = Object.defineProperties;
var Q = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, x = Object.prototype.propertyIsEnumerable;
var v = (e, t, r) => t in e ? K(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, N = (e, t) => {
  for (var r in t || (t = {}))
    A.call(t, r) && v(e, r, t[r]);
  if (s)
    for (var r of s(t))
      x.call(t, r) && v(e, r, t[r]);
  return e;
}, k = (e, t) => M(e, Q(t));
var B = (e, t) => {
  var r = {};
  for (var i in e)
    A.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
  if (e != null && s)
    for (var i of s(e))
      t.indexOf(i) < 0 && x.call(e, i) && (r[i] = e[i]);
  return r;
};
import { jsxs as l, jsx as d, Fragment as U } from "react/jsx-runtime";
import o from "../../../node_modules/prop-types/index.es.js";
import { useState as H, useEffect as S } from "react";
import * as V from "./style.es.js";
import { SegmentedCard as W, SegmentedCardOptions as X, SegmentedCardItem as Y, SegmentedCardItemHeader as Z, SegmentedCardItemHeaderTop as _, SegmentedCardItemHeaderBody as ee, SegmentedCardItemHeaderBottom as te, SegmentedCardItemContent as re, SegmentedCardContent as ne } from "./style.es.js";
import { Tooltip as ie } from "../Tooltip/Tooltip.es.js";
import { Radio as oe } from "../../Inputs/Option/Radio.es.js";
import { Typography as P } from "../../Typography/Typography.es.js";
import { Image as de } from "../Image/Image.es.js";
function u({
  activeTab: e,
  className: t,
  defaultActiveTab: r,
  onChange: i,
  options: m,
  updateHash: c = !0,
  isPage: j = !1,
  isAnchoring: z = !1,
  error: R = !1,
  isLeftAlignedDescription: q = !1,
  disabled: y = !1,
  direction: D = "horizontal"
}) {
  const [a, b] = H(r), h = m.find((n) => n.value === a), [f, E] = H(!1);
  S(() => {
    a && !f && setTimeout(() => {
      E(!0);
    }, 2e3);
  }, [a]), S(() => {
    e && (b(e), c && (window.location.hash = e));
  }, [e]);
  const F = (n) => {
    b(n), c && (window.location.hash = n), i && i(n);
  };
  return S(() => () => {
    c && (window.location.hash = "");
  }, []), /* @__PURE__ */ l(W, { isSelected: f && !!a, className: t, children: [
    /* @__PURE__ */ d(X, { children: m.map((n, L) => {
      const $ = n, {
        value: g = "",
        tooltip: w = null,
        icon: O = null,
        image: p,
        title: I = "",
        description: G = "",
        bottomContent: T = null
      } = $, J = B($, [
        "value",
        "tooltip",
        "icon",
        "image",
        "title",
        "description",
        "bottomContent"
      ]), C = g === a;
      return /* @__PURE__ */ d(Y, k(N({ "data-tip": w, className: C ? "active" : "", onClick: () => {
        n.disabled || y || F(g);
      }, $isActive: !!C, $disabled: !!n.disabled || y, $error: !!R }, J), { children: /* @__PURE__ */ d(ie, { tooltipConfig: {
        placement: "top-start"
      }, content: w, children: /* @__PURE__ */ l(U, { children: [
        !(n != null && n.hiddenInput) && /* @__PURE__ */ d(oe, { className: "segmented-card-radio", checked: C }),
        /* @__PURE__ */ l(Z, { children: [
          /* @__PURE__ */ l(_, { $hasImage: !!p, $direction: D, children: [
            O,
            /* @__PURE__ */ l(ee, { children: [
              /* @__PURE__ */ d(P, { variant: "body1SemiBold", style: {
                textAlign: "center"
              }, children: I }),
              /* @__PURE__ */ d(P, { variant: "body2", style: {
                textAlign: q ? "left" : "center"
              }, color: "fg", emphasis: "weak", children: G })
            ] })
          ] }),
          T && /* @__PURE__ */ d(te, { children: T })
        ] }),
        !f && p && /* @__PURE__ */ d(re, { children: /* @__PURE__ */ d(de, { src: p, alt: I, width: 240, height: 180 }) })
      ] }) }) }), `${L.toString()}-${g}`);
    }) }),
    /* @__PURE__ */ d(ne, { isPage: j, children: z ? m.map((n) => n.children) : h == null ? void 0 : h.children })
  ] });
}
const ae = {
  activeTab: o.string,
  defaultActiveTab: o.string,
  className: o.string,
  direction: o.oneOf(["horizontal", "vertical"]),
  onChange: o.func,
  options: o.array.isRequired,
  updateHash: o.bool,
  isPage: o.bool,
  isAnchoring: o.bool,
  isLeftAlignedDescription: o.bool,
  disabled: o.bool,
  error: o.bool
};
u.S = V;
u.displayName = "SegmentedCard";
u.propTypes = ae;
//! migrate to new structure
export {
  u as SegmentedCard,
  ae as segmentedCardPropTypes
};
//# sourceMappingURL=SegmentedCard.es.js.map
